/* @flow */

import { baseColor } from '@e180/ui/lib/token/color';
import { white } from '@e180/ui/lib/token/palette';

export default {
  root: {
    display: 'block',

    width: 12,
    height: 12,

    backgroundColor: ({ accentColor }: Object) => accentColor,
    border: ['solid', 2, white],
    borderRadius: '50%',
  },
  'root-large': {
    width: 14,
    height: 14,

    borderWidth: 1,
  },
  'root-darkBg': {
    borderColor: baseColor,
  },
};
